<template>
    <BasicTile class="list-tile" @click="tileClicked()">
        <div class="w-100 list-tile__container">
            <div class="list-tile__item-1">
                <slot name="icon"></slot>
            </div>
            <div class="d-flex flex-column justify-center h-100 list-tile__item-2">
                <slot name="details"></slot>
            </div>
            <div class="list-tile__item-3">
                <slot name="append-right"></slot>
            </div>
        </div>
        <div class="list-tile__item-5" v-if="$slots['append-bottom']">
            <slot name="append-bottom"></slot>
        </div>
    </BasicTile>
</template>

<script setup>
import BasicTile from '@/components/Tiles/Basic-Tile.vue';

const emit = defineEmits(['click']);

const tileClicked = () => {
    emit('click');
}
</script>
